export const WrapStyledHtmlTemplate = (body: string): string => `
<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <!-- CSS Reset -->
    <style>
      * {
        font-family: Arial, sans-serif !important;
      }
    </style>
    <!-- Styling -->
    <style>
      /* Typography */
      h1 {
        font-size: 1.875rem;
        line-height: 2.5rem;
        letter-spacing: -0.013rem;
      }

      h2 {
        font-size: 1.875rem;
        line-height: 2.5rem;
        letter-spacing: -0.013rem;
        margin: 0;
      }

      h3 {
        font-size: 1rem;
        line-height: 1.5rem;
        letter-spacing: -0.013rem;
        margin: 0;
      }

      p {
        line-height: 1.5rem;
        padding: 0;
        margin: 0;
      }

      p.foot-note {
        font-size: 0.875rem;
        color: #6D6D6D;
      }

      /* main styling */
      body {
        max-width: 1280px;
        margin: 32px auto;
      }

      hr {
        opacity: 0.6;
        border-width: 0px 0px 1px;
        border-image: initial;
        border-color: #EAEAEA;
        border-style: solid;
        width: 100%;
        margin: 32px 0;
      }

      .page-break-before {
        page-break-before: always;
      }

      /* Kpi section  */
      .kpi-cards {
        margin-top: 32px;
      }

      .kpi-card {
        page-break-after: auto;
        border-bottom: 1px solid;
        border-color: #EAEAEA;
        box-shadow: 0px 0px 12px -8px rgb(0 0 0 / 35%);
        box-sizing: border-box;
        border-radius: 4px;
        overflow-anchor: none;
        margin-bottom: 20px;
      }

      .kpi-card-header {
        display: flex;
        align-items: center;
        width: 100%;
        outline: 0;
        box-sizing: border-box;
        border: 1px solid #EAEAEA;
        border-radius: 4px 4px 0px 0px;
        background: #6D6D6D;
        padding: 12px 24px 12px 24px;
        background-color: #FCFCFC;
      }

      .kpi-card-content {
        padding: 16px 24px 16px 24px;
        border-left: 1px solid;
        border-right: 1px solid;
        border-color: #EAEAEA;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        overflow-x: auto;
      }

      /* Kpi section -- table  */
      table {
        font-variant-numeric: lining-nums tabular-nums;
        border-collapse: separate;
        width: 100%;
        border-spacing: 0 8px;
        margin-bottom: 20px;
      }

      thead {
        display: table-header-group;
        box-sizing: border-box;
      } 

      th {
        text-align: start;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 8px;
        padding-bottom: 8px;
        letter-spacing: 0;
        line-height: 1.5;
        color: #000000;
        border-bottom: 1px solid;
        border-color: #DDDDDD;
        background: #F8F8F8;
        border-radius: 4px 4px 0 0;
        width: auto;
      }

      tbody tr {
        outline: thin solid;
        outline-color: #EAEAEA;
        background: #FCFCFC;
        border-radius: 4px;
      }

      td {
        padding: 8px 16px 8px 16px;
        line-height: 1.5;
        border-bottom: 1px solid;
        border-color: #FCFCFC;
        letter-spacing: 0;
      }

      /* Kpi section -- values  */
      .kpi-values {
        margin-top: 16px;
        margin-bottom: 16px;
      }

      .kpi-value-data {
        font-size: 60px;
        line-height: 60px;
        margin-bottom: 16px;
      }

      /* Kpi section -- table resets */

      .kpi-table {
        border-spacing: 16px 16px;
        margin-bottom: 0px;
      }

      .kpi-tr {
        outline: none;
        background-color: inherit;
        border-radius: 0px;
      }

      .kpi-td {
        vertical-align: top;
        width: 33%;
        letter-spacing: 0;
        padding: 0px;
        border: none;
        letter-spacing: inherit;
      }

      /* Review section */
      .review-section {
        page-break-before: always;
      }

      .review-cards {
        margin-top: 16px;
      }

      .review-card {
        display: grid;
        grid-gap: 32px;
        border-radius: 5px;
        background-color: #F5F5F5;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        padding-bottom: 32px;
        margin-bottom: 20px;
      }

      .review-card-response {
        padding: 1.25rem;
        background-color: #FFFFFF;
      }

      .review-card-response .tqc-typography {
        padding: 8px 0px 8px 0px;
      }
    </style>
  </head>
  <body>
    ${body}
  </body>
</html>
`;
